






























































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Student } from '@/modules/student';
import { Account } from '@/modules/admin/me';
import { GenderTypes } from '@/enums/genderTypes';
import { ElForm } from 'element-ui/types/form';
import { UserTypes } from '@/enums/userTypes';
import { FunctionTypes } from '@/enums/functionTypes';
import store from '@/store';

Component.registerHooks([
  'beforeRouteEnter',
]);

@Component
export default class StudentEdit extends Vue {
  private GenderTypes = GenderTypes;
  private FunctionTypes = FunctionTypes;

  @Prop() private studentId: string;

  private isEdit = false;
  private isManualInputId = true;

  private yubinbangoScript: HTMLScriptElement;

  private formRule = {
    userId: [
      { validator: this.validateUserId, trigger: 'blur' },
      { pattern: '^[a-zA-Z0-9]*$', trigger: 'blur', message: '英数字のみを入力してください' },
    ],
    lastName: [
      { required: true, message: '氏名（姓）を入力してください' },
    ],
    firstName: [
      { required: true, message: '氏名（名）を入力してください' },
    ],
    lastNameKana: [
      { required: true, message: 'カナ（姓）を入力してください' },
      { pattern: '^[ァ-ヶー]*$', trigger: 'blur', message: '全角カタカナを入力してください' },
    ],
    firstNameKana: [
      { required: true, message: 'カナ（名）を入力してください' },
      { pattern: '^[ァ-ヶー]*$', trigger: 'blur', message: '全角カタカナを入力してください' },
    ],
    postalCode: [
      { pattern: '^[0-9]*$', trigger: 'blur', message: '数字のみを入力してください' },
    ],
    phone: [
      { pattern: '^[-0-9]*$', trigger: 'blur', message: '数字とハイフン(-)のみを入力してください' },
    ],
  };

  private validateUserId(rule: any, value: string, callback: any) {
    if (!this.isEdit && this.isManualInputId) {
      if (!value) {
        callback(new Error('生徒IDを入力してください'));
      } else {
        callback();
      }
    } else {
      callback();
    }
  }

  get user(): Account {
    return this.$store.state.me.user;
  }

  get student(): Student {
    return this.$store.state.student.selectedStudent;
  }

  get isMini(): boolean {
    return (this as any).$mq === 'mini';
  }

  get availableFunction(): number {
    if (!this.user) {
      return 0;
    }
    return this.user.availableFunctionbit;
  }

  @Watch('student.postalCode')
  private changePostalCode(postalCode: string | null) {
    if (!postalCode || postalCode.trim().length < 7) { return; }
    const base = this;
    const YubinBango = (window as any).YubinBango;
    const result = new YubinBango.Core(postalCode, (address: any) => {
      if (!!address.region) {
        base.student.address = `${address.region}${address.locality}${address.street}${address.extended}`;
        (base.$refs.address as any).focus();
      }
    });
  }

  private beforeRouteEnter(to: any, from: any, next: any) {
    switch (store.getters['auth/userType']) {
      case UserTypes.Admin:
      case UserTypes.Owner:
      case UserTypes.AdminTutor:
        next();
        break;
      default:
        next({ name: 'Error' });
        break;
    }
  }

  private created() {
    this.appendScript();
  }

  private mounted() {
    this.loadData();
  }

  private deactivated() {
    this.removeScript();
    this.$destroy();
  }

  private appendScript() {
    const head = document.getElementsByTagName('head')[0];
    this.yubinbangoScript = document.createElement('script');
    this.yubinbangoScript.src = 'https://yubinbango.github.io/yubinbango-core/yubinbango-core.js';
    this.yubinbangoScript.charset = 'UTF-8';
    head.appendChild(this.yubinbangoScript);
  }

  private removeScript() {
    if (!!this.yubinbangoScript) {
      const head = document.getElementsByTagName('head')[0];
      head.removeChild(this.yubinbangoScript);
    }
  }

  private async loadData() {
    const page = String(this.$route.name);
    const isEdit = (page.toUpperCase() === 'studentEdit'.toUpperCase());

    this.isEdit = isEdit;

    if (isEdit) {
      try {
        await this.$store.dispatch('student/selectStudent', this.studentId);
      } catch (error) {
        //
      }

      if (!this.student) {
        this.$router.push({
          name: 'StudentList',
        });
      }
    } else {
      this.$store.commit('student/initSelectedStudent');
    }
    this.$nextTick(() => {
      (this.$refs.form as ElForm).clearValidate();
    });
  }

  private onManualInputIdChanged() {
    this.$nextTick(() => {
      (this.$refs.form as ElForm).validateField('userId', () => {
        // dummy
      });
    });
  }

  private onPreSchoolChange({ id, name }: { id: string, name: string }) {
    this.student.ordinaryPreSchoolId = id;
    this.student.ordinaryPreSchoolName = name;
  }

  private onElementarySchoolChange({ id, name }: { id: string, name: string }) {
    this.student.ordinaryElementarySchoolId = id;
    this.student.ordinaryElementarySchoolName = name;
  }

  private onMiddleSchoolChange({ id, name }: { id: string, name: string }) {
    this.student.ordinaryMiddleSchoolId = id;
    this.student.ordinaryMiddleSchoolName = name;
  }

  private onHighSchoolChange({ id, name }: { id: string, name: string }) {
    this.student.ordinaryHighSchoolId = id;
    this.student.ordinaryHighSchoolName = name;
  }

  private onRegist() {
    (this.$refs.form as ElForm).validate((valid) => {
      if (!valid) {
        return false;
      } else {
        if (this.isEdit) {
          this.editStudent();
        } else {
          this.createStudent();
        }
      }
    });
  }

  private async createStudent() {
    const fullName = `${this.student.lastName}　${this.student.firstName}`;

    try {
      await this.$confirm(`生徒『${fullName}』を登録します。よろしいですか？`, '生徒登録', {
        confirmButtonText: '登録',
        cancelButtonText: 'キャンセル',
        type: 'info'
      });
    } catch (error) {
      return;
    }

    if (!this.isManualInputId) {
      this.student.userId = '';
    }

    try {
      await this.$store.dispatch('student/createStudent', this.student);
      this.$router.push({ name: 'StudentList' });
      this.$notify({
        title: '生徒登録完了',
        message: `生徒『${fullName}』を登録し、<br>案内資料を発行しました。`,
        position: 'bottom-right',
        dangerouslyUseHTMLString: true,
      });
    } catch (error) {
      this.$notify.error({
        title: '生徒登録エラー',
        message: error.message,
        position: 'bottom-right'
      });
    }
  }

  private async editStudent() {
    const fullName = `${this.student.lastName}　${this.student.firstName}`;

    try {
      await this.$confirm(`生徒『${fullName}』を変更します。よろしいですか？`, '生徒変更', {
        confirmButtonText: '変更',
        cancelButtonText: 'キャンセル',
        type: 'info'
      });
    } catch (error) {
      return;
    }

    try {
      await this.$store.dispatch('student/editStudent', this.student);
      this.$router.push({ name: 'StudentList' });
      this.$notify({
        title: '生徒変更完了',
        message: `生徒『${fullName}』を変更しました。`,
        position: 'bottom-right'
      });
    } catch (error) {
      this.$notify.error({
        title: '生徒変更エラー',
        message: error.message,
        position: 'bottom-right'
      });
    }
  }

  private onCancel() {
    this.$router.push({ name: 'StudentList' });
  }
}
